import { render, staticRenderFns } from "./OrderPreviousDetailIframe.vue?vue&type=template&id=1bfc7ab4&"
import script from "./OrderPreviousDetailIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderPreviousDetailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports